import Bugsnag from '@bugsnag/js';
import * as i1 from '@bugsnag/plugin-angular';
import { BugsnagErrorHandler } from '@bugsnag/plugin-angular';
import * as i0 from '@angular/core';
import { ErrorHandler, Injectable, Inject } from '@angular/core';

function bugsnagErrorHandlerFactory({ apiKey, appVersion, autoTrackSessions, releaseStage, isDeployed, groupingRules, }) {
    return () => new BugsnagErrorHandler(Bugsnag.createClient({
        apiKey,
        appVersion,
        autoTrackSessions,
        releaseStage,
        onError: (event) => {
            if (!isDeployed) {
                return false;
            }
            // Pass error message through all known message grouping rules
            (groupingRules || []).forEach((message) => {
                const errorMessage = event.errors[0].errorMessage;
                const newMsg = errorMessage.replace(message.regex, message.msg);
                if (newMsg === errorMessage) {
                    return;
                }
                if (message.customEvent) {
                    message.customEvent(event);
                }
                if (message.context) {
                    event.context = message.context;
                }
                event.groupingHash = `${event.errors[0].errorClass}: ${newMsg}`;
            });
        },
    }));
}

class BugsnagService {
    constructor(errorHandler) {
        this.errorHandler = errorHandler;
    }
    sendError(error, severity = 'error') {
        this.errorHandler.bugsnagClient.notify(error, (event) => {
            event.severity = severity;
        });
    }
}
BugsnagService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.0.1", ngImport: i0, type: BugsnagService, deps: [{ token: ErrorHandler }], target: i0.ɵɵFactoryTarget.Injectable });
BugsnagService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.0.1", ngImport: i0, type: BugsnagService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.0.1", ngImport: i0, type: BugsnagService, decorators: [{
            type: Injectable,
            args: [{ providedIn: 'root' }]
        }], ctorParameters: function () { return [{ type: i1.BugsnagErrorHandler, decorators: [{
                    type: Inject,
                    args: [ErrorHandler]
                }] }]; } });

// Error handler

/**
 * Generated bundle index. Do not edit.
 */

export { BugsnagService, bugsnagErrorHandlerFactory };
